/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ role: NonNullable<unknown> }} Perks_Trigger_RoleInputs */



/**
* | output |
* | --- |
* | "Holding {role}" |
*
* @param {Perks_Trigger_RoleInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perks_trigger_role = /** @type {((inputs: Perks_Trigger_RoleInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perks_Trigger_RoleInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`С ролью ${i?.role}`)
	return /** @type {LocalizedString} */ (`Holding ${i?.role}`)
});